import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class EmployeePostdicApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'employee-postdic'
  }

}